import { render, staticRenderFns } from "./PoiContent.vue?vue&type=template&id=5478678a&"
import script from "./PoiContent.vue?vue&type=script&lang=ts&"
export * from "./PoiContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports